import { TextField, TextFieldProps } from "@mui/material";
import { useEffect, useState } from "react";
import isEmail from "utils/validators/isEmail";

type Props = TextFieldProps & {
  value?: string;
};

export default function EmailField({ error, value, ...props }: Props) {
  const [_value, setValue] = useState(
    value != undefined ? value.toLowerCase() : undefined,
  );

  useEffect(() => {
    if (value === undefined || value === "") {
      setValue(undefined);
      return;
    }
    setValue(value.toLowerCase());
  }, [value]);

  return (
    <TextField
      label="Email"
      type="email"
      autoComplete="email"
      error={error || (_value != undefined && !isEmail(_value))}
      {...props}
      onChange={(e) => {
        e.target.value = e.target.value.toLowerCase();
        setValue(e.target.value);
        props.onChange && props.onChange(e);
      }}
      value={_value || ""}
    />
  );
}
